"use client";
import { useState } from "react";
import Image from "next/image";
import { Play, Pause } from "lucide-react";
import Link from "next/link";
import "./style.css";
type PlayButtonProps = {
  isPlaying: boolean;
  size: number;
  iconColor: string;
  className?: string;
  idleBackgroundColor: string;
  activeBackgroundColor: string;
  play: () => void;
  stop: () => void;
  tileUrl: string;
};

const PlayButton: React.FC<PlayButtonProps> = ({ isPlaying, size, iconColor, className, play, tileUrl }) => {
  const [numClicks, setNumClicks] = useState(0);
  const [canGoToTile, setCanGoToTile] = useState(false);
  const [buttonClassName, setButtonClassName] = useState(className);

  const handleClick = () => {
    setNumClicks(numClicks + 1);
    if (numClicks === 0) {
      play();
      setButtonClassName(`${className} active`);

      setTimeout(() => {
        setCanGoToTile(true);
        setButtonClassName(`${className} ready-to-navigate`);
      }, 10 * 1000);
    } else if (canGoToTile) {
      window.location.href = tileUrl;
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => {
          if (!isPlaying) {
            handleClick();
          }
        }}
        className={`play-button-container ${buttonClassName}`}
      >
        <div className="background-wrapper">
          <div className="background-1 col-start-1 row-start-1"></div>
          <div className="background-2 col-start-1 row-start-1"></div>
          <div className="background-3 col-start-1 row-start-1"></div>
        </div>
        <div className="button-text relative z-10 flex items-center justify-center rounded bg-black text-white">
          {numClicks === 0 ? (
            <>
              {isPlaying ? (
                <Pause size={size * 0.5} className="mr-2" color={iconColor} />
              ) : (
                <Play size={size * 0.5} className="mr-2" color={iconColor} />
              )}
              <span>{isPlaying ? "We made you something" : "We made you something"}</span>
            </>
          ) : canGoToTile ? (
            <Link href={tileUrl}>See what we made for you</Link>
          ) : (
            <div>
              <Image src="/soundwave.gif" alt="Loading" width={89} height={40} />
            </div>
          )}
        </div>
      </button>
    </div>
  );
};

export default PlayButton;
